import React from "react";
import { useLocation } from "react-router-dom";
import { GlobalContainer } from "../../common/components/Container";
import ServiceProviderScheduleTable from "./components/ServiceProviderScheduleTable";
const ServiceProviderSchedule = () => {
  const { state } = useLocation();
  return (
    <GlobalContainer theme="purple" animated={false}>
      <ServiceProviderScheduleTable serviceProviderData={state} />
    </GlobalContainer>
  );
};

export default ServiceProviderSchedule;
